import { formatUSD } from "@/lib/api";
import { ArrowUp, ArrowDown } from "lucide-react";

export default function PriceTicker({ prices }) {
  if (!prices?.length) {
    return <div className="border-t border-border/60 h-8 shimmer" />;
  }
  const row = prices.concat(prices).concat(prices);
  return (
    <div className="border-t border-border/60 overflow-hidden" data-testid="global-ticker">
      <div className="marquee py-2">
        {row.map((p, i) => {
          const up = p.change_24h >= 0;
          return (
            <div
              key={i}
              className="flex items-center gap-3 px-6 whitespace-nowrap text-xs font-mono border-r border-border/40"
            >
              <span className="text-zinc-500">{p.symbol}</span>
              <span className="text-white">{formatUSD(p.price)}</span>
              <span className={up ? "text-emerald-400 flex items-center gap-1" : "text-red-400 flex items-center gap-1"}>
                {up ? <ArrowUp className="w-3 h-3" strokeWidth={2} /> : <ArrowDown className="w-3 h-3" strokeWidth={2} />}
                {Math.abs(p.change_24h).toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
